import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _cache = null;
let _inflight = null;

async function fetchAssets() {
    if (_cache) return _cache;
    if (_inflight) return _inflight;
    _inflight = axios
        .get(`${API}/settings/brand-assets`)
        .then((r) => {
            _cache = r.data?.assets || {};
            return _cache;
        })
        .catch(() => {
            _cache = {};
            return _cache;
        })
        .finally(() => { _inflight = null; });
    return _inflight;
}

// Kick the request off as soon as this module is imported anywhere — by
// the time the hero / category cards mount the URL map is usually ready,
// so we never flash a broken image even though the local /brand/ files
// have been retired in favour of the CDN.
fetchAssets();

/**
 * Resolve a logical brand-asset name (e.g. `hero_desktop`) into a CDN URL.
 *
 * The map is fetched once at app boot, cached at module scope, and shared
 * across all consumers. While the request is in flight we render an
 * inline transparent placeholder (so the layout is reserved but the page
 * never shows a broken image icon).
 */
export default function useBrandAsset(name) {
    const [url, setUrl] = useState(() => _cache?.[name] || null);

    useEffect(() => {
        if (url) return;
        let cancelled = false;
        fetchAssets().then((map) => {
            if (cancelled) return;
            setUrl(map[name] || null);
        });
        return () => { cancelled = true; };
    }, [name, url]);

    // 1x1 transparent SVG keeps the <img> element valid and avoids the
    // browser's broken-image icon during the brief pre-cache window.
    return url || "data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%221%22%20height%3D%221%22%3E%3C/svg%3E";
}
